import { render, staticRenderFns } from "./SignUpSuccess.vue?vue&type=template&id=2dd95496&scoped=true"
import script from "./SignUpSuccess.vue?vue&type=script&lang=js"
export * from "./SignUpSuccess.vue?vue&type=script&lang=js"
import style0 from "./SignUpSuccess.vue?vue&type=style&index=0&id=2dd95496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd95496",
  null
  
)

export default component.exports